import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import PublicNavbar from "@/components/PublicNavbar";
import PublicFooter from "@/components/PublicFooter";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ success }) {
  const [sp] = useSearchParams();
  const txnid = sp.get("txnid");
  const [p, setP] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!txnid) { setLoading(false); return; }
    api.get(`/payments/status/${txnid}`).then((r) => setP(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [txnid]);

  const isSuccess = (p?.status === "success") || (success && !p);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <PublicNavbar />
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-md w-full p-10 rounded-2xl border border-slate-200 bg-white text-center shadow-sm">
          {loading ? (
            <><Loader2 className="animate-spin mx-auto" size={36} /><div className="mt-4 text-slate-500">Verifying payment...</div></>
          ) : isSuccess ? (
            <>
              <CheckCircle2 size={56} className="mx-auto text-emerald-500" />
              <h1 className="heading text-2xl font-bold mt-4">Payment Successful!</h1>
              <p className="text-slate-500 mt-2 text-sm">You can now access your test series.</p>
              {txnid && <div className="text-xs text-slate-400 font-mono mt-2">TxnID: {txnid}</div>}
            </>
          ) : (
            <>
              <XCircle size={56} className="mx-auto text-red-500" />
              <h1 className="heading text-2xl font-bold mt-4">Payment Failed</h1>
              <p className="text-slate-500 mt-2 text-sm">We couldn't process your payment. Please try again.</p>
              {txnid && <div className="text-xs text-slate-400 font-mono mt-2">TxnID: {txnid}</div>}
            </>
          )}
          <Link to="/student/test-series" className="mt-6 inline-block bg-brand text-white font-semibold rounded-full px-6 py-2.5" data-testid="payment-back-button">
            Back to Test Series
          </Link>
        </div>
      </div>
      <PublicFooter contact={null} />
    </div>
  );
}
